import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    const userId = localStorage.getItem('userId');
    const email = localStorage.getItem('email');
    const refreshToken = localStorage.getItem('refreshToken');
    const tenantId = localStorage.getItem('tenantId');
    const name = localStorage.getItem('name');

    if (token && role && userId && email && refreshToken) {
      setUser({ userId, role, token, email, refreshToken, tenantId, name });
    }
    setLoading(false);
  }, []);

  const login = async (loginId, password) => {
    try {
      const response = await api.post('/auth/login', { email: loginId, password });
      const {
        access_token,
        refresh_token,
        role,
        user_id,
        tenant_id,
        email: userEmail,
        name,
      } = response.data;

      localStorage.setItem('token', access_token);
      localStorage.setItem('refreshToken', refresh_token);
      localStorage.setItem('role', role);
      localStorage.setItem('userId', user_id);
      localStorage.setItem('email', userEmail);
      if (tenant_id) localStorage.setItem('tenantId', tenant_id);
      else localStorage.removeItem('tenantId');
      if (name) localStorage.setItem('name', name);
      else localStorage.removeItem('name');

      setUser({
        userId: user_id,
        role,
        token: access_token,
        email: userEmail,
        refreshToken: refresh_token,
        tenantId: tenant_id || null,
        name: name || null,
      });
      return { success: true, role };
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: error.response?.data?.detail || 'Login failed' };
    }
  };

  const logout = () => {
    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) {
      api.post('/auth/logout', { refresh_token: refreshToken }).catch((error) => {
        console.error('Logout error:', error);
      });
    }
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('role');
    localStorage.removeItem('userId');
    localStorage.removeItem('email');
    localStorage.removeItem('tenantId');
    localStorage.removeItem('name');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
